import { render, staticRenderFns } from "./Theses25.vue?vue&type=template&id=0cc1cb66&scoped=true&"
import script from "./Theses25.vue?vue&type=script&lang=js&"
export * from "./Theses25.vue?vue&type=script&lang=js&"
import style0 from "./Theses25.vue?vue&type=style&index=0&id=0cc1cb66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1cb66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
